import { getGlobalHeadersAsObject } from "..";

/** One mandatory requirement on the assignment's latest role description. */
export interface SignatureRequirement {
	id: number;
	text: string;
}

/** Histogram bucket — N persons share this exact (unmet, risk_flags) signature. */
export interface QueueSignature {
	unmet_req_ids: number[];
	risk_flags: string[];
	count: number;
}

export interface LlmNoQueueSignatures {
	mandatory_requirements: SignatureRequirement[];
	risk_flags: string[];
	signatures: QueueSignature[];
}

export async function getLlmNoQueueSignatures(
	assignmentId: number
): Promise<LlmNoQueueSignatures> {
	const res = await fetch(`/api/v2/llm-no-queue-signatures/${assignmentId}/`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	});
	if (!res.ok) {
		throw new Error(`llm-no-queue-signatures failed: ${res.status}`);
	}
	return (await res.json()) as LlmNoQueueSignatures;
}
